import React from 'react'
import ReactDOM from 'react-dom/client'
import Home from './components/Home.js'

const WIDGET_ID_PREFIX = 'app_CommonwealthGames2026'
const MOUNT_MARKER_ATTR = 'data-commgames-mounted'
const ROOT_MARKER_ATTR = 'data-commgames-root'
const DEBUG_PARAM = 'commgames_debug'
const rootsByElement = new WeakMap()

const isDebugEnabled = () => {
  try {
    const params = new URLSearchParams(window.location.search)
    return params.get(DEBUG_PARAM) === '1' || window.__COMM_GAMES_DEBUG__ === true
  } catch {
    return false
  }
}

const logDebug = (...args) => {
  if (isDebugEnabled()) {
    console.info('[commgames]', ...args)
  }
}

const getWidgetDivs = () => {
  const byIdPrefix = Array.from(document.querySelectorAll(`div[id^="${WIDGET_ID_PREFIX}"]`))
  const byRootMarker = Array.from(document.querySelectorAll(`div[${ROOT_MARKER_ATTR}="1"]`))
  const uniqueDivs = []
  const seen = new Set()

  ;[...byIdPrefix, ...byRootMarker].forEach((div) => {
    if (seen.has(div)) return
    seen.add(div)
    uniqueDivs.push(div)
  })

  return uniqueDivs
}

const hasRuntimeCollisionRisk = () => {
  return (
    typeof Function !== 'function' ||
    typeof Function.prototype.bind !== 'function' ||
    typeof ReactDOM?.createRoot !== 'function'
  )
}

// Find all widget containers and mount instances
function initializeWidgets() {
  if (hasRuntimeCollisionRisk()) {
    console.error('[commgames] Runtime preflight failed. Skipping widget bootstrap.', {
      hasFunction: typeof Function === 'function',
      hasFunctionBind: typeof Function?.prototype?.bind === 'function',
      hasCreateRoot: typeof ReactDOM?.createRoot === 'function'
    })
    return
  }

  const widgetDivs = getWidgetDivs()
  logDebug('bootstrap start', { count: widgetDivs.length })
  
  widgetDivs.forEach(div => {
    const mode = div.getAttribute('data-commgames-mode') || 'multi'
    const initialTab = div.getAttribute('data-commgames-tab') || 'medals'
    const noHeightLimitAttr = div.getAttribute('data-commgames-no-height-limit')
    const noHeightLimit = noHeightLimitAttr !== null && noHeightLimitAttr !== 'false' && noHeightLimitAttr !== '0'

    const alreadyMounted = div.getAttribute(MOUNT_MARKER_ATTR) === '1'
    const existingRoot = rootsByElement.get(div)

    if (alreadyMounted || existingRoot) {
      logDebug('skip duplicate mount', { id: div.id, mode, initialTab })
      return
    }

    if (div.innerHTML.trim() !== '') {
      logDebug('skip non-empty container', { id: div.id })
      return
    }

    try {
      const root = ReactDOM.createRoot(div)
      rootsByElement.set(div, root)
      div.setAttribute(MOUNT_MARKER_ATTR, '1')

      root.render(
        <React.StrictMode>
          <Home mode={mode} initialTab={initialTab} noHeightLimit={noHeightLimit} />
        </React.StrictMode>
      )

      logDebug('mounted', { id: div.id, mode, initialTab, noHeightLimit })
    } catch (error) {
      div.removeAttribute(MOUNT_MARKER_ATTR)
      console.error('[commgames] Failed to initialize widget root', {
        id: div.id,
        mode,
        initialTab,
        noHeightLimit,
        error
      })
    }
  })
}

// Wait for DOM to be ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initializeWidgets)
} else {
  initializeWidgets()
}
